import ons from "onsenui";
import * as React from "react";
import { API } from "../API";
import { ScheduledVisitRescheduleScreen } from "../components/Visits/Request/ScheduledVisitRescheduleScreen";
import { ScheduledVisitEditRequestParams } from "../messages/ScheduledVisitEditRequest";
import { VisitInstanceDetails } from "../messages/Visit";
import { retryableModalNetworkRequest } from "../NetworkRequest";
import { STRINGS } from "../strings";
import { translate } from "../translate";

export interface RescheduleRequestActivityProps {
  api: API;
  onBackClick: () => void;
  scheduledVisit: VisitInstanceDetails;
  isCancel: boolean;
}

export interface RescheduleRequestActivityState {}

export class RescheduleRequestActivity extends React.Component<
  RescheduleRequestActivityProps,
  RescheduleRequestActivityState
> {
  constructor(props: RescheduleRequestActivityProps) {
    super(props);

    this.state = {};
  }

  handleSubmitClick = async (params: ScheduledVisitEditRequestParams) => {
    const didCreate = await retryableModalNetworkRequest(() => {
      return this.props.api.createRescheduleRequest(this.props.scheduledVisit.id, params);
    }, true);
    if (didCreate === null) {
      return;
    }

    if (!didCreate) {
      await ons.notification.alert({
        animation: "none",
        modifier: "material",
        title: translate(STRINGS.ERROR),
        message: translate(STRINGS.YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT),
        cancelable: true,
      });
    } else {
      this.props.onBackClick();
    }
  };

  render() {
    return (
      <ScheduledVisitRescheduleScreen
        initialEndTime={this.props.scheduledVisit.endTimeLocal}
        initialStartTime={this.props.scheduledVisit.startTimeLocal}
        isCancel={this.props.isCancel}
        onSubmitClick={this.handleSubmitClick}
        onBackClick={this.props.onBackClick}
      />
    );
  }
}
